module.exports = __webpack_public_path__ + "static/media/footer-background-character.0092484e.gif";